import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/checkbox/checkbox.less';

export default class Checkbox extends PureComponent {
    static propTypes = {
        /** Содержимое внутри лейбла checkbox*/
        children: PropTypes.node,
        /** Открываемый контент при checked=true */
        openingContent: PropTypes.node,
        /** Обработчик onChange, в качестве аргумента передает event */
        onChange: PropTypes.func,
        /** Функция для получения рутового DOM элемента компонента Checkbox*/
        innerRef: PropTypes.func,
        /** Свойства лейбла checkbox */
        labelProps: PropTypes.object,
        /** Свойства обертки checkbox */
        wrapperProps: PropTypes.object,
        /** Флаг checked контрола по умолчанию для uncontrolled checkbox */
        defaultChecked: PropTypes.bool,
        /** Флаг checked контрола */
        checked: PropTypes.bool,
        /** Флаг indeterminate контрола */
        indeterminate: PropTypes.bool,
        /** Флаг disabled контрола */
        disabled: PropTypes.bool,
        /** Флаг не валидности контрола */
        invalid: PropTypes.bool,
    };

    static defaultProps = {
        indeterminate: false,
        disabled: false,
        invalid: false,
    };

    checkboxRef = React.createRef();

    componentDidMount() {
        this.checkboxRef.current.indeterminate = this.props.indeterminate;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.indeterminate !== this.props.indeterminate) {
            this.checkboxRef.current.indeterminate = this.props.indeterminate;
        }
    }

    renderOpeningContent() {
        if (!this.props.openingContent) {
            return null;
        }

        return <div className="bloko-checkbox__opening-content">{this.props.openingContent}</div>;
    }

    render() {
        const {
            children,
            invalid,
            innerRef,
            openingContent,
            indeterminate,
            labelProps,
            wrapperProps,
            ...checkboxProps
        } = this.props;

        return (
            <label
                className={classnames('bloko-checkbox', {
                    'bloko-checkbox_invalid': invalid,
                })}
                {...wrapperProps}
                ref={innerRef}
            >
                <input {...checkboxProps} ref={this.checkboxRef} className="bloko-checkbox__input" type="checkbox" />
                <span className="bloko-checkbox__text" {...labelProps}>
                    {children}
                    {this.renderOpeningContent()}
                </span>
            </label>
        );
    }
}
